<div class="position-relative d-flex flex-column h-100 text-grey"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane"
     cdkDragBoundary="body"
     [cdkDragDisabled]="!toogleDialog">
  <div class="modal-header pb-1 align-items-baseline" cdkDragHandle>
    <div class="flex-grow-1">
      <h4 class="modal-title synchpc-primary" id="modal-title">{{ heading }}</h4>
      <div class="d-flex align-items-center mt-2">
        <label for="">File Name : </label>
        <input [(ngModel)]="fileName" type="text" class="fileNameInput flex-grow-1 ms-2">
      </div>
    </div>
    <div class="fileSearch" *ngIf="!toogleDialog" [ngClass]="{
      'h-50': !openReplace,
      'sync-90': openReplace
    }">
      <div class="inputAndResults d-flex flex-column flex-grow-1">
        <div class="flex-grow-1 align-items-center ">
          <input class="searchInput"
                 type="text"
                 placeholder="Search"
                 value="{{ searchTerm }}"
                 (input)="searchKeyword($event.target.value)"
                 (click)="updateVar()" />
          <label class="searchResults" for="">{{ currentWordIndex }}/{{ totalWordCount }}</label>
        </div>
        <div class="d-flex align-items-center flex-grow-1" style="border-top: 1px solid black;" *ngIf="openReplace">
          <input #replaceVar
                 class="searchInput"
                 type="text"
                 placeholder="Replace with"
                 value="" />
          <i class="bi bi-check2" title="Confirm Replace" (click)="replaceChar(replaceVar.value)"></i>
        </div>
      </div>
      <div class="searchIcons">
        <button class="isCaseSensitive"
                (click)="makeCaseSensitive()"
                title="{{ isSensitiveTitle }}"
                [ngStyle]="
            isSensitive ? { color: 'var(--s-primary-color)', 'font-weight': '600' } : {}
          ">
          Aa
        </button>
        <span title="Previous"
              [class.iconDisabled]="totalWordCount == 0"
              (click)="findPrevious()"
              class="bi bi-arrow-up-short"></span>
        <span title="Next"
              [class.iconDisabled]="totalWordCount == 0"
              (click)="findNext()"
              class="bi bi-arrow-down-short"></span>
        <button class="isCaseSensitive"
                (click)="openReplace = !openReplace"
                title="Replace"
                style="color: var(--s-primary-color);">
          R
        </button>
        <span title="Clear Search"
              (click)="clearSearch()"
              class="bi bi-x-lg text-danger"></span>
      </div>
    </div>
    <i style="z-index: 9999; margin-right: 1rem"
       class="bi bi-arrows-fullscreen text-danger"
       [ngClass]="{
        'bi-arrows-fullscreen': !toogleFullScreen,
        'bi-fullscreen-exit': toogleFullScreen
      }"
       [title]="toogleFullScreen ? 'Exit full screen' : 'Full screen'"
       color="warn"
       (click)="onFullScreen()"></i>
    <i style="z-index: 1; margin-right: 1rem"
       class="bi bi-dash text-danger"
       [ngClass]="{
        'bi-dash-lg': !toogleDialog,
        'bi-fullscreen': toogleDialog,
        'minmax-dialog': toogleDialog
      }"
       color="warn"
       (click)="toogleDialogMinMax()"
       [title]="toogleDialog ? 'Maximize' : 'Minimize'"></i>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onCancel()" title="Close"></i>
  </div>
  <div class="modal-content-container">
    <div class="modal-body flex-grow-1 editor-container">
      <form action="" [formGroup]="editorForm" class="d-flex flex-column h-100">
        <!-- <textarea formControlName="content" class="editorArea flex-grow-1" name="" [innerHTML]="editorForm.get('content').value | highlight: searchTerm:regexCode" placeholder="Type here..."></textarea> -->
        <!-- <p class="editorArea flex-grow-1" #jobEditor contenteditable="true" [innerHTML]="getJobElementText() | highlight: searchTerm:regexCode"></p> -->
        <p #jobEditor
           contenteditable="true"
           cdkFocusInitial
           class="editor-content"
           [innerHTML]="editorForm.get('content').value | highlight: searchTerm:regexCode"></p>
        <div class="d-flex align-items-center mt-2 d-none">
          <label for="">File Name : </label>
          <input formControlName="fileName" type="text" class="fileNameInput flex-grow-1 ms-2">
        </div>
      </form>
    </div>
    </div>
    <div class="modal-footer pt-1">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Close</button>
      <button type="button" class="btn btn-primary" (click)="onSubmit()" cdkFocusInitial>
        Save
      </button>
    </div>
    <ngx-spinner bdColor="rgba(0,0,0,0)"
                 size="default"
                 color="var(--s-primary-color)"
                 type="ball-spin"
                 [fullScreen]="false"
                 zIndex="0"
                 name="fileEditor">
      <p class="pleaseWait">
        fetching data ...
      </p>
    </ngx-spinner>
  </div>
